import React from 'react'
import styles from './Footer.module.css'

const Footer = () => {
  return <footer className={styles.footer}></footer>
}

export default Footer
